// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floating-calling-container {\n  position: fixed;\n  bottom: 85px; /* Adjusted to stack above WhatsApp button */\n  right: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #e0e0e0;\n  border-radius: 30px;\n  padding: 5px 0;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.floating-calling-container .ant-btn {\n  margin: 5px 0;\n  border: none;\n}\n\n.floating-calling-container .ant-btn:hover {\n  opacity: 0.8;\n}", ""]);
// Exports
module.exports = exports;
